<script>
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import { axiosGetPost } from '@router/axiosGetPost'
import 'vue2-datepicker/index.css'
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  decimal,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'
import integer from 'vuelidate/lib/validators/integer'

export default {
  name: 'DuplicatedLocalCharge',
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    localId: { type: [String, Number], default: null },
  },
  data() {
    return {
      locationOptions: [
        { text: 'Port', value: 'port' },
        { text: 'Country', value: 'country' },
        { text: 'Port Country', value: 'port-country' },
        { text: 'Country Port', value: 'country-port' },
      ],
      companyUsers: [],
      chargers: [],
      ports: [],
      countries: [],
      origins: [],
      destinations: [],
      typeDestinations: [],
      calculationTypes: [],
      currencies: [],
      carriers: [],
      location: '',
      disabledOrigin: false,
      disabledDestiny: false,
      labelLocation: ['', ''],
      portAll: [{ id: 1485, name: 'ALL' }],
      countryAll: [{ id: 250, name: 'ALL' }],
      seletedOptions: {
        allOrigin: false,
        allDestiny: false,
        location: '',
        companyUser: {},
        charge: {},
        origin: [],
        destiny: [],
        calculationType: {},
        typeDestination: {},
        validation: [],
        currency: {},
        carrier: [],
        amount: 0,
        originException: [],
        destinyException: [],
      },
      originExceptionShow: true,
      destinyExceptionShow: true,
      typeException: 'port',
      counter: false,
      loadingData: true,
      errorShow: false,
      error: '',
    }
  },
  validations: {
    seletedOptions: {
      companyUser: { required },
      charge: { required },
      origin: { required },
      destiny: { required },
      calculationType: { required },
      typeDestination: { required },
      validation: { required },
      currency: { required },
      carrier: { required },
      amount: {
        decimal,
        minValue: (value) => {
          return value >= 1.0
        },
      },
    },
  },
  watch: {
    location() {
      this.locationSetting()
    },
    'seletedOptions.allOrigin': {
      handler() {
        if (!this.seletedOptions.allOrigin) {
          this.seletedOptions.originException = []
        }
      },
      immediate: true,
    },
    'seletedOptions.allDestiny': {
      handler() {
        if (!this.seletedOptions.allDestiny) {
          this.seletedOptions.destinyException = []
        }
      },
      immediate: true,
    },
  },

  computed: {},
  created() {
    this.getData()
    this.location = 'port'
  },
  mounted() {},

  methods: {
    loadDataSelects(data) {
      this.ports = data.ports
      this.countries = data.countries
      this.typeDestinations = data.type_destiny
      this.calculationTypes = data.calculation_type
      this.currencies = data.currencies
      this.companyUsers = data.company_users
      this.carriers = data.carriers
      this.chargers = data.chargers
    },
    syncroniceData(data) {
      this.seletedOptions.companyUser = data.company_user
      this.seletedOptions.charge = data.charge
      this.seletedOptions.typeDestination = data.type_destiny
      this.seletedOptions.calculationType = data.calculation_type
      this.seletedOptions.currency = data.currency
      this.seletedOptions.amount = data.amount
      this.seletedOptions.carrier = data.carrier
      this.seletedOptions.location = data.location
      this.seletedOptions.origin = data.origin
      this.seletedOptions.destiny = data.destiny
      this.seletedOptions.originException = data.origin_exception
      this.seletedOptions.destinyException = data.destiny_exception
      this.seletedOptions.validation = [
        new Date(data.validity),
        new Date(data.expire),
      ]
    },
    getData() {
      this.loadingData = true
      axiosGetPost(
        'post',
        '/localCharges/updateLocalCharge',
        {
          id: this.localId,
        },
        'Load Data Duplicate Localcharge FCL'
      ).then((response) => {
        const data = response.data
        this.loadDataSelects(data['selects'])
        this.counter = false
        this.location = data['local'].location
        this.seletedOptions.location = data['local'].location
        this.locationSetting_hold()
        this.syncroniceData(data['local'])
        this.seletedOptions.allOrigin = this.verificationAllPlaces('origin')
        this.seletedOptions.allDestiny = this.verificationAllPlaces('destiny')
        this.loadingData = false
        //this.counter = true
        return data
      })
    },
    locationSetting_hold() {
      switch (this.location) {
        case 'port':
          this.labelLocation = ['Port', 'Port']
          this.origins = this.ports
          this.destinations = this.ports
          break
        case 'country':
          this.labelLocation = ['Country', 'Country']
          this.origins = this.countries
          this.destinations = this.countries
          break
        case 'port-country':
          this.labelLocation = ['Port', 'Country']
          this.origins = this.ports
          this.destinations = this.countries
          break
        case 'country-port':
          this.labelLocation = ['Country', 'Port']
          this.origins = this.countries
          this.destinations = this.ports
          break
        default:
          console.log(`Sorry, we are out of ${this.location}.`)
      }
    },
    verificationAllPlaces(place) {
      let result = false
      if (
        [this.portAll[0].id, this.countryAll[0].id].includes(
          this.seletedOptions[place][0].id
        ) == true
      ) {
        result = true
      }
      return result
    },
    locationSetting() {
      this.locationSetting_hold()
      if (this.counter == true) {
        this.locationAllSetting()
        this.seletedOptions.allOrigin = false
        this.seletedOptions.allDestiny = false
        this.cleanLocationsSelects()
      }
      this.counter = true
      this.seletedOptions.location = this.location
    },
    locationAllSetting(typyLocation) {
      let sO = 'seletedOptions'
      let keyLc = typyLocation == 'origin' ? 'origin' : 'destiny'
      let typAll = typyLocation == 'origin' ? 'allOrigin' : 'allDestiny'
      if (!this[sO][typAll]) {
        switch (this.location) {
          case 'port':
            this[sO][keyLc] = this.portAll
            break
          case 'country':
            this[sO][keyLc] = this.countryAll
            break
          case 'port-country':
            this[sO][keyLc] =
              typyLocation == 'origin' ? this.portAll : this.countryAll
            break
          case 'country-port':
            this[sO][keyLc] =
              typyLocation == 'origin' ? this.countryAll : this.portAll
            break
          default:
            console.log(`Sorry, we are out of ${this.location}.`)
        }
      } else {
        this[sO][keyLc] = []
      }
    },
    cleanLocationsSelects() {
      this.seletedOptions.origin = []
      this.seletedOptions.destiny = []
      this.seletedOptions.originException = []
      this.seletedOptions.destinyException = []
    },
    loadTypeCharge() {
      axiosGetPost(
        'put',
        '/localCharges/getSelects',
        {
          company_user: this.seletedOptions.companyUser['id'],
        },
        'Load charge by company - Duplicate Local charge'
      ).then((response) => {
        this.seletedOptions.charge = {}
        const data = response.data
        this.chargers = data.chargers
        return data
      })
    },
    validate_fields() {
      let response = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$toastr.e('Field is required')
        response = false
      }
      return response
    },
    formatDate(date) {
      let adjustedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      )
      return adjustedDate.toISOString().split('T')[0]
    },
    save_local() {
      if (this.validate_fields()) {
        let pdata = this.seletedOptions
        let date = this.seletedOptions.validation.map(this.formatDate)
        this.loadingData = true
        axiosGetPost(
          'post',
          '/localCharges/saveGLocal',
          {
            data: {
              company_user: pdata.companyUser,
              charge: pdata.charge,
              origin: pdata.origin,
              destiny: pdata.destiny,
              calculation_type: pdata.calculationType,
              type_destination: pdata.typeDestination,
              validation: date,
              currency: pdata.currency,
              carrier: pdata.carrier,
              amount: pdata.amount,
              location: pdata.location,
              origin_exception: pdata.originException,
              destiny_exception: pdata.destinyException,
            },
          },
          'Add - Duplicating Local Charge FCL'
        ).then((response) => {
          this.loadingData = false
          console.log(response)
          if (response.success) {
            this.$toastr.s('Duplicating Local Charge FCL')
            this.$emit('closeModal')
          } else {
            this.errorShow = true
            this.error = 'Error to save'
            this.$toastr.e('Error to save')
            this.$emit('closeModal')
          }
          return response
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="col-md col-md-12">
          <div
            v-if="loadingData"
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <b-spinner
                label="Loading..."
                variant="primary"
                class="ml-3"
              ></b-spinner>
            </div>
          </div>

          <div v-else-if="errorShow === true">
            <div
              class="row align-items-center justify-content-center"
              style="height: 300px"
            >
              <div class="col-12 col-md-8 text-center">
                <feather type="frown" class="icon-xxl icon-dual-info"></feather>
                <h6 class="text-muted">{{ error }}</h6>
              </div>
            </div>
          </div>
          <div v-else-if="!loadingData">
            <div class="form-group row">
              <div class="col-sm-7">
                <label for="">Locations Options</label>
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="location"
                    :options="locationOptions"
                    :aria-describedby="ariaDescribedby"
                    name="radio-options"
                    class="mt-2 mt-sm-2"
                  >
                  </b-form-radio-group>
                </b-form-group>
              </div>
              <div class="col-md-5">
                <label>Company User</label>
                <multiselect
                  id="companyUser"
                  v-model="seletedOptions.companyUser"
                  :options="companyUsers"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  @input="loadTypeCharge"
                  class="mt-0 mt-sm-0 mb-0"
                  required
                >
                </multiselect>
                <div
                  v-if="$v.seletedOptions.companyUser.$error"
                  style="color: red"
                  >* This value is required.</div
                >
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>Type</label>
                <multiselect
                  id="charge"
                  v-model="seletedOptions.charge"
                  :options="chargers"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                  required
                >
                </multiselect>
                <div v-if="$v.seletedOptions.charge.$error" style="color: red"
                  >* This value is required.</div
                >
              </div>
              <div class="col-md-4">
                <b-form-checkbox
                  v-model="seletedOptions.allOrigin"
                  name="check-button"
                  switch
                  @change="locationAllSetting('origin')"
                  class="mb-2"
                >
                  <span style="color: blue"> ALL </span> - Origin
                  {{ labelLocation[0] }}
                </b-form-checkbox>
                <multiselect
                  id="origin"
                  v-model="seletedOptions.origin"
                  :options="origins"
                  select-label=""
                  :multiple="true"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  :disabled="seletedOptions.allOrigin"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div v-if="$v.seletedOptions.origin.$error" style="color: red">
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <b-form-checkbox
                  v-model="seletedOptions.allDestiny"
                  name="check-button"
                  switch
                  @change="locationAllSetting('destiny')"
                  class="mb-2"
                >
                  <span style="color: blue"> ALL </span> - Destination
                  {{ labelLocation[1] }}
                </b-form-checkbox>
                <multiselect
                  id="destiny"
                  v-model="seletedOptions.destiny"
                  :options="destinations"
                  select-label=""
                  :multiple="true"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  :disabled="seletedOptions.allDestiny"
                  aria-readonly="true"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div v-if="$v.seletedOptions.destiny.$error" style="color: red">
                  * This value is required.
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>Destination Type</label>
                <multiselect
                  id="destinytype"
                  v-model="seletedOptions.typeDestination"
                  :options="typeDestinations"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.seletedOptions.typeDestination.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Validation</label>
                <date-picker
                  v-model="seletedOptions.validation"
                  class="col-md-12"
                  type="date"
                  range
                  placeholder="Select date range"
                >
                </date-picker>
                <div
                  v-if="$v.seletedOptions.validation.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Calculation Type</label>
                <multiselect
                  id="calculationT"
                  v-model="seletedOptions.calculationType"
                  select-label=""
                  :options="calculationTypes"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.seletedOptions.calculationType.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label>Carrier</label>
                <multiselect
                  id="carrierw"
                  v-model="seletedOptions.carrier"
                  :options="carriers"
                  select-label=""
                  :multiple="true"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div v-if="$v.seletedOptions.carrier.$error" style="color: red">
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Currency</label>
                <multiselect
                  id="currency"
                  v-model="seletedOptions.currency"
                  select-label=""
                  :options="currencies"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
                <div
                  v-if="$v.seletedOptions.currency.$error"
                  style="color: red"
                >
                  * This value is required.
                </div>
              </div>
              <div class="col-md-4">
                <label>Amount</label>
                <b-form-input
                  id="name"
                  v-model="seletedOptions.amount"
                  min="0.0"
                  step="0.01"
                  type="number"
                  value
                  placeholder="Write amount"
                  required
                >
                </b-form-input>
                <div v-if="$v.seletedOptions.amount.$error" style="color: red">
                  * This value is required.
                </div>
              </div>
            </div>
            <hr />
            <div class="form-group row">
              <div v-if="seletedOptions.allOrigin" class="col-md-6">
                <label>Exception Origi - {{ labelLocation[0] }}</label>
                <multiselect
                  id="carrierw"
                  v-model="seletedOptions.originException"
                  :options="origins"
                  :multiple="true"
                  select-label=""
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
              </div>
              <div v-if="seletedOptions.allDestiny" class="col-md-6">
                <label>Exception Destiny - {{ labelLocation[1] }}</label>
                <multiselect
                  id="carrierw"
                  v-model="seletedOptions.destinyException"
                  :options="destinations"
                  select-label=""
                  :multiple="true"
                  placeholder="Select one"
                  label="name"
                  track-by="name"
                  class="mt-0 mt-sm-0 mb-0"
                >
                </multiselect>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center mt-3">
                <!-- Asegúrate de añadir un margen en la parte superior para separar el botón del último elemento de tu formulario -->
                <b-button variant="primary" class="col-4" @click="save_local"
                  >Submit</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* O puedes cambiarlo a la altura que prefieras */
}
</style>